export default "assets/images/icons/C&A-black-ef2de3a4.svg";